import accessibilityStyles from './Accessibility/Accessibility.module.css';

export const visuallyHidden = (accessibilityStyles as Record<string, string>).visuallyHidden ?? '';
